import AudioCubeApiCallerInstance from '../utils/AudioCubeApiCallerInstance';
import { SOUNDBOX_API_ENDPOINTS } from '../URLConstants';

export const GetAllScheme = async (pageNo, limit, where) => {
  const res = await AudioCubeApiCallerInstance.get(SOUNDBOX_API_ENDPOINTS.SCHEME_URL, {
    params: {
      page: pageNo,
      limit,
      ...(where && { where: JSON.stringify(where) })
    }
  });
  return res;
};

export const GetSchemeById = async (schemeId) => {
  const response = await AudioCubeApiCallerInstance.get(
    `${SOUNDBOX_API_ENDPOINTS.SCHEME_URL}/${schemeId}`
  );
  return response;
};

export const CreateScheme = async (payload) => {
  const response = await AudioCubeApiCallerInstance.post(
    SOUNDBOX_API_ENDPOINTS.SCHEME_URL,
    payload
  );
  return response;
};

export const UpdateScheme = async (schemeId, payload) => {
  const response = await AudioCubeApiCallerInstance.patch(
    `${SOUNDBOX_API_ENDPOINTS.SCHEME_URL}/${schemeId}`,
    payload
  );
  return response;
};

export const GetSchemeStatus = async (startDate, endDate) => {
  const response = await AudioCubeApiCallerInstance.get(
    `${SOUNDBOX_API_ENDPOINTS.SCHEME_URL}/status?startDate=${startDate}&endDate=${endDate}`
  );
  return response;
};

export const DeleteScheme = async (schemeId) => {
  const response = await AudioCubeApiCallerInstance.delete(
    `${SOUNDBOX_API_ENDPOINTS.SCHEME_URL}/${schemeId}`
  );
  return response;
};
